@if (!hideControl) {
  <div>
    @if (showFieldAsEdit && !readOnlyUser && canUpdateDocuments) {
      <div
        [class.my-4]="!noMargin">
        <topo-color-item-select
          [selectedUId]="selectedStepUId"
          [label]="selectedStatusName"
          [colorCode]="selectedStatusColorCode"
          itemLabel="statusName"
          itemColorCode="statusHtmlColorCode"
          [items]="workflowStepListItems"
          [isXLarge]="true"
          (itemSelected)="stepSelected($event)"
        isActive="false"></topo-color-item-select>
      </div>
    } @else {
      <div class="workflow-status-display">
        <div
          class="workflow-color"
          [ngStyle]="{ 'background-color': selectedStatusColorCode }">
          &nbsp;
        </div>
        <div class="workflow-status">{{ selectedStatusName }}</div>
      </div>
    }
  </div>
}
<topo-workflow-transition-form
  [isActive]="showTransitionForm"
  [editView]="workflowTransitionView"
  [document]="document$ | async"
  [schema]="(dataset$ | async)?.schema"
  [workflowStepUId]="selectedNextWorkflowStep?.uId"
  (close)="onCloseTransitionForm()"
  (save)="onSaveTransitionForm($event)"
[dataset]="dataset$ | async"></topo-workflow-transition-form>
